import { addThousandsSeparators } from '../../../utils';

const REGEX_VALID_CURRENCY = new RegExp('^-?\\d+(?:.\\d{0,2})?');

export const transformToValidCurrency = (value: string) => value.match(REGEX_VALID_CURRENCY)?.[0] || '0';

export const transformForRendering = (value: number | string, prefix: string): string | null => {
  if (!value) return null;

  const stringValue = typeof value === 'number' ? (value / 100).toString() : value;
  const validValue = transformToValidCurrency(stringValue);

  const stringParts = validValue.split('.');
  const dollars = addThousandsSeparators(stringParts[0]);
  const cents = stringParts[1];

  const lastCharIsDot = validValue.slice(-1) === '.';

  return cents ? `${prefix + dollars}.${cents}` : prefix + dollars + (lastCharIsDot ? '.' : '');
};

export const transformForValidation = (value: string): number =>
  Math.round(parseFloat(transformToValidCurrency(value)) * 100);

export const stripNonFloatChars = (value: string) => value.replace(/[^0-9.]+/g, '');
